import RequestInstance from '../request.instance';
import { IResponse } from '../request.interface';
import { ITrending } from '../token/token.response.interface';
import { IFollowTokenReq, IFollowTokensReq } from './user.request.interface';
import { ITransfer, ITransferTokenMetadata } from './user.response.interface';

class UserApiService {
  private readonly requestInstance: RequestInstance;
  constructor() {
    this.requestInstance = new RequestInstance();
  }

  // 获取关注的代币列表
  async getFollowTokenListApi(params: IFollowTokensReq): Promise<IResponse<ITrending[]>> {
    return await this.requestInstance.businessRequest({
      url: `/follow/tokens`,
      method: 'GET',
      params,
    });
  }

  // 关注token
  async followToken(data: IFollowTokenReq): Promise<IResponse<string[]>> {
    return await this.requestInstance.businessRequest({
      url: `/users/follow-token`,
      method: 'POST',
      data,
    });
  }

  // 获取充提记录
  async getAddressTransfer(params: {
    address: string;
    tokenAddress: string;
  }): Promise<IResponse<{ items: ITransfer[]; metadata: { tokens: ITransferTokenMetadata } }>> {
    return await this.requestInstance.businessRequest({
      url: `/token/account-transfers`,
      method: 'GET',
      params,
    });
  }
}

export default new UserApiService();
